<template>
  <div class="view-wrap">
    <section class="view-content">
      <div class="section-inner">
        <div class="container">
          <div v-if="showForm"  class="row">
            <p v-if="notice" class="notice alert alert-danger">{{ notice }}</p>
            <div class="col-12 col-sm-4 col-md-3 support-bear">
              <img srcset="./images/supportbear.png 1x, ./images/supportbear@2x.png 2x" src="./images/supportbear.png" alt="">
            </div>
            <div class="col-12 col-sm-8 col-md-9">
              <p v-if="alert" class="alert alert-warning">
              </p>
              <h1 class="h3">Contact a Support Bear</h1>
              <p v-if="!thanks" class="small-copy">
                Rawr! Please note we will do our ‘beary’ best to respond to all inquiries within 48 hours. We appreciate your patience and understanding.
              </p>
              <form v-if="!thanks" class="questions form-area" v-on:submit.prevent="submit()">
                <fieldset class="question-block">
                  <legend><h2 class="h4">{{questions.main.copy}}</h2></legend>
                  <div class="radios">
                    <label v-for="(question, key) in questions.main.options" :key="key">
                      <input v-model="main" type="radio" name="main-issue" :value="key">{{ question.copy }}
                    </label>
                  </div>
                </fieldset>
                <fieldset v-if="main && questions.mainDetails[main]" class="question-block">
                  <legend><h2 class="h4">{{questions.mainDetails[main].copy}}</h2></legend>
                  <div class="radios">
                    <label v-for="(question, key) in questions.mainDetails[main].options" :key="key">
                      <input v-model="mainDetail" type="radio" name="main-detail" :value="key" @change="addFollowups()">{{ question.copy }}
                    </label>
                  </div>
                </fieldset>
                <div v-if="main &&
                  mainDetail &&
                  questions.mainDetails[main].options[mainDetail].followups">
                  <fieldset
                    v-for="followup in questions.mainDetails[main].options[mainDetail].followups"
                    :key="followup"
                    class="question-block">
                    <legend><h2 class="h4">{{questions.followups[followup].copy}}</h2></legend>
                    <div v-if="questions.followups[followup].type === 'radio'" class="radios">
                      <label v-for="(option, index) in questions.followups[followup].options" :key="index">
                        <input
                          type="radio"
                          :ref="followup + '-detail'"
                          :name="followup + '-detail'"
                          :value="option"
                          v-model="followups[followup]">{{ option }}
                        <span v-if="questions.followups[followup].additionalInput &&
                            questions.followups[followup].additionalInput[option]"
                            class="additional-input">
                            {{ questions.followups[followup].additionalInput[option] }}
                          <input
                            type="text"
                            :ref="followup + '-additionalInput'">
                        </span>
                      </label>
                    </div>
                    <div v-if="questions.followups[followup].type === 'dropdown'">
                      <div class="select-wrap">
                        <select v-model="followups[followup]" name="tunnels" id="tunnels">
                          <option value="" disabled selected>Select</option>
                          <option v-for="location in questions.followups[followup].options" :value="location.country" :key="location.code">{{location.country}}</option>
                        </select>
                        <span class="caret"></span>
                      </div>
                    </div>
                    <div v-if="questions.followups[followup].type === 'text'">
                      <p v-if="followup === 'os'">How to check:
                        <a href="https://support.microsoft.com/en-ca/help/13443/windows-which-version-am-i-running" target="_blank">Windows</a>,
                        <a href="https://support.apple.com/en-ca/HT201260" target="_blank">Mac</a>,
                        <a href="https://support.apple.com/en-ca/HT201685" target="_blank">iPhone / iPad</a>,
                        <a href="https://support.google.com/android/answer/7680439?hl=en" target="_blank">Android</a>
                      </p>
                      <input v-model="followups[followup]" type="text" :name="followup + '-detail'">
                    </div>
                    <div v-if="questions.followups[followup].type === 'textarea'">
                      <textarea v-model="followups[followup]" :name="followup + '-detail'" maxlength='1000'></textarea>
                    </div>
                  </fieldset>
                </div>
                <div v-if="main && mainDetail">
                  <div class="question-block">
                    <h2 class="h4">Upload a screenshot if necessary</h2>
                    <image-upload @imageResponse="imageResponse" @imageUploading="imageUploading = true"></image-upload>
                  </div>
                  <fieldset class="question-block">
                    <label for="email"><h2 class="h4">Account email address (we'll send a reply to this email)</h2></label>
                    <div class="input-wrap" :class="{ 'show-error' : errors.current === 'email' }">
                      <announce>
                        <p class="field-error">Grr... Please enter a valid email address</p>
                      </announce>
                      <input v-if="loggedInEmail" id="email" type="email" :value="loggedInEmail" name="email" disabled="disabled">
                      <input v-else type="email" v-model="email" id="email" name="email">
                    </div>
                  </fieldset>
                  <announce>
                    <p class="field-error" :class="{ 'show-error' : submitError }">{{ submitError }}</p>
                  </announce>
                  <submit-button @submit="submit" :submitting="submitting" :finished="finished" :disabled="imageUploading">Send Message</submit-button>
                </div>
              </form>
              <div v-if="thanks">
                <announce>
                  <p><strong>Rawr! We've received your message.</strong></p>
                  <p v-if="holiday">
                    Thanks for submitting a ticket! A Support Bear will be in touch shortly. While we’d like to send speedy Yuletide Greetings, our Support Bears are currently relaxing in their caves, caring for their cubs, and enjoying the holiday season. Not to worry, we’ll still be doing our ‘beary’ best to get back to you as quickly as our paws can type (when not full of festive goodies, of course), but the wait may be longer than usual. It may take up to 5 business days to receive a response from us. In the meantime, we wish you the happiest of holidays, from our sleuth to yours!
                  </p>
                  <p v-else>
                    Thanks for submitting a ticket! A Support Bear will be in touch shortly. We do our best to respond to all inquiries within 48 hours.
                  </p>
                  <p>Don't forget, you can always check out our <a :href="external.help">help section</a> while you wait for a response.</p>
                </announce>
              </div>
            </div>
          </div>
          <div v-else class="row login-wrap">
            <div class="col-12">
              <img srcset="./images/supportbear.png 1x, ./images/supportbear@2x.png 2x" src="./images/supportbear@2x.png" class="support-bear" alt="">
              <h2 class="h4 text-center mbottom-10">Please log in <br>to contact support.</h2>
              <login-form></login-form>
              <p class="mtop-10" data-cy="bypass-login">Unable to log in? <button class="plain link bypass-login-btn" @click="bypass = true">Click Here</button>.</p>
            </div>
          </div>
        </div>
      </div>
    <ai-chat-bot v-if='!isAiBlockedCountry'/>
    </section>
  </div>
</template>

<script>
import is from 'is_js'
import validator from '../../mixins/validator.js'
import Cookies from 'js-cookie'
import login from '@/components/login-form/login-form'
import submitButton from '@/components/submit-button/submit-button'
import imageUpload from './components/image-upload/image-upload'
import questions from '@/data/support-form.js'
import aiChatBot from '@/components/ai-chat-bot/ai-chat-bot.vue'

export default {
  name: 'support',
  components: {
    'login-form': login,
    'submit-button': submitButton,
    'image-upload': imageUpload,
    'ai-chat-bot': aiChatBot
  },
  mixins: [validator],
  data () {
    return {
      is,
      alert: false, // note: can put date-checks here for scheduled support notices
      holiday: false, // note: can put date-checks here for scheduled support notices
      thanks: false,
      questions,
      main: '',
      mainDetail: '',
      followups: {},
      screenshot: '',
      email: '',
      imageUploading: false,
      notice: '',
      showWarning: false,
      submitted: false,
      submitting: false,
      finished: false,
      submitError: '',
      bypass: false,
      isAiBlockedCountry: false,
      watcher: null
    }
  },
  created: async function () {
    this.$store.dispatch('getUserData')
    this.isAiBlockedCountry = await this.$store.state.locationService.isAiBlockedCountry()
  },
  beforeDestroy: function () {
    // unwatch this function
    if (this.watcher) {
      this.watcher()
    }
  },
  computed: {
    showForm: function () {
      return this.$store.getters.isLoggedIn || this.bypass
    },
    description: function () {
      return this.followups.describeIssue ||
        this.followups.describe ||
        this.followups.featureRequest ||
        this.questions.mainDetails[this.main].options[this.mainDetail].copy ||
        'I need some support beary badly'
    },
    loggedInEmail: function () {
      return this.$store.getters.userData.user
    },
    validations: function () {
      const email = this.loggedInEmail || this.email
      let validations = {}
      validations = Object.assign(validations, {
        'email': [email, this.is.email(email)]
      })
      return validations
    }
  },
  mounted: function () {
    const notice = this.$route.query.notice
    if (notice && notice === 'delete') {
      this.notice = 'Grrr... We aren\'t able to delete your account automatically. Please contact support for assistance.'
      this.bypass = true
    }
  },
  methods: {
    addFollowups: function () {
      const followups = this.questions.mainDetails[this.main].options[this.mainDetail].followups
      if (followups) {
        for (const followup of followups) {
          if (!this.followups[followup]) this.followups[followup] = ''
        }
      }
    },
    gatherInfo: function () {
      const info = []
      info.push(`${this.questions.main.copy}: ${this.questions.main.options[this.main].copy}`)
      info.push(`${this.questions.mainDetails[this.main].copy}: ${this.questions.mainDetails[this.main].options[this.mainDetail].copy}`)
      for (const followup in this.followups) {
        const question = this.questions.followups[followup].copy
        const answer = this.followups[followup]
        let additionalInput = ''
        if (this.questions.followups[followup].additionalInput &&
          this.questions.followups[followup].additionalInput[answer]) {
          additionalInput = ` [${this.$refs[followup + '-additionalInput'][0].value}]`
        }
        if (answer && answer !== this.description) {
          info.push(`${question}: ${answer + additionalInput}`)
        }
      }

      if (this.screenshot) {
        info.splice(0, 0, 'File Uploaded: ' + this.screenshot)
      }
      return JSON.stringify(info)
    },
    makeRequest: function () {
      if (this.submitting) return
      this.submitting = true
      const data = {
        title: '[TB] ' + this.description.substr(0, 44).replace(/(\r\n|\n|\r)/gm, ''),
        message: this.description,
        additionalInfo: this.gatherInfo(),
        fromAddress: this.loggedInEmail || this.email
      }
      this.$http.post(this.ENV.coreBaseUrl + '/sendSupportFeedback',
        data,
        {
          headers:
          {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      ).then(response => {
        const time = new Date()
        time.setTime(time.getTime() + 1 * 3600 * 1000)
        Cookies.set('supportSpam', true, { expires: time, secure: true })
        this.thanks = true
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.notice = ''
        this.submitting = false
        this.finished = true
      }).catch(error => {
        if (error) {
          this.submitError = 'Whoops... something went wrong with your request. Please refresh and try again.'
          this.submitting = false
        }
      })
    },
    submit: function () {
      this.submitError = ''
      this.submitted = true
      if (this.errors.all.length === 0) {
        if (Cookies.get('supportSpam')) {
          this.submitError = 'Oops, you\'ve already sent a request in the last hour.'
        } else {
          this.makeRequest()
        }
      }
    },
    imageResponse: function (response) {
      if (response) {
        this.screenshot = response
      } else {
        this.screenshot = ''
      }
      this.imageUploading = false
    }
  },
  watch: {
    main: function () {
      this.submitted = false
      this.submitError = ''
      this.mainDetail = ''
    }
  }
}
</script>

<style scoped lang="stylus" src="./support.styl" >
